// The next/config runtime configuration is deprecated in Next.js 16.
// The recommended approach is to use environment variables.
const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL;
const FRONTEND_CNET_URL = process.env.NEXT_PUBLIC_FRONTEND_CNET_URL;
const FRONTEND_GIFTS_URL = process.env.NEXT_PUBLIC_FRONTEND_GIFTS_URL;
const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT;
const DEFAULT_COUNTRY_CODE = process.env.NEXT_PUBLIC_DEFAULT_COUNTRY_CODE;
const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
const CONSUMER_ID = process.env.NEXT_PUBLIC_CONSUMER_ID;
const IDEAL_POSTCODES_API_KEY = process.env.NEXT_PUBLIC_IDEAL_POSTCODES_API_KEY;
const AUTO_ADDRESS_API_KEY = process.env.NEXT_PUBLIC_AUTO_ADDRESS_API_KEY;
const AUTO_ADDRESS_GIFTS_API_KEY = process.env.NEXT_PUBLIC_AUTO_ADDRESS_GIFTS_API_KEY;
const ROLLBAR_CLIENT_ACCESS_TOKEN = process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_ACCESS_TOKEN;
const COOKIEBOT_ID = process.env.NEXT_PUBLIC_COOKIEBOT_ID;
const HTTP_AUTH_USER = process.env.HTTP_AUTH_USER;
const HTTP_AUTH_PASS = process.env.HTTP_AUTH_PASS;
const PAYMENT_SECRET_HEADER_NAME = process.env.NEXT_PUBLIC_PAYMENT_SECRET_HEADER_NAME;
const CSP_CENTRAL_ENDPOINT_ID = process.env.NEXT_PUBLIC_CSP_CENTRAL_ENDPOINT_ID;
const DEFAULT_CURRENCY = process.env.NEXT_PUBLIC_DEFAULT_CURRENCY;
const GTM_QUERY = process.env.NEXT_PUBLIC_GTM_QUERY;
const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
const GIFTS_GTM_QUERY = process.env.NEXT_PUBLIC_GIFTS_GTM_QUERY;
const GIFTS_GTM_ID = process.env.NEXT_PUBLIC_GIFTS_GTM_ID;
const GIFTS_COOKIEBOT_ID = process.env.NEXT_PUBLIC_GIFTS_COOKIEBOT_ID;
const PAYPAL_CLIENT_TEST = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_TEST;
const PAYPAL_CLIENT_LIVE = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_LIVE;
const PAYPAL_GIFTS_CLIENT_TEST = process.env.NEXT_PUBLIC_PAYPAL_GIFTS_CLIENT_TEST;
const PAYPAL_GIFTS_CLIENT_LIVE = process.env.NEXT_PUBLIC_PAYPAL_GIFTS_CLIENT_LIVE;
const TEST_SUITE_SECRET_HEADER_NAME = process.env.NEXT_PUBLIC_TEST_SUITE_SECRET_HEADER_NAME;
const STRIPE_PUBLISHABLE_TEST = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_TEST;
const STRIPE_PUBLISHABLE_LIVE = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_LIVE;
const STRIPE_GIFTS_PUBLISHABLE_TEST = process.env.NEXT_PUBLIC_STRIPE_GIFTS_PUBLISHABLE_TEST;
const STRIPE_GIFTS_PUBLISHABLE_LIVE = process.env.NEXT_PUBLIC_STRIPE_GIFTS_PUBLISHABLE_LIVE;

/**
 * Single donation type.
 */
const SD = 'single_donation';

/**
 * Recurring donation type.
 */
const RG = 'recurring_donation';

/**
 * Each step must have a machine name (object key).
 * In edge cases when you need to refer to the step using integer, use stepId.
 */
const DONATION_FORM_STEPS_BY_REGION = {
  IE: {
    amount: { path: '/checkout', stepId: 1, stepIndicatorName: 'Name & email' },
    address: { path: '/checkout/address', stepId: 2, stepIndicatorName: 'Address' },
    preferences: { path: '/checkout/preferences', stepId: 3 },
    payment: { path: '/checkout/payment', stepId: 5, stepIndicatorName: 'Payment' },
    'thank-you': { path: '/checkout/thank-you', stepId: 6 },
  },
  GB: {
    amount: { path: '/checkout', stepId: 1, stepIndicatorName: 'Name & email' },
    address: { path: '/checkout/address', stepId: 2, stepIndicatorName: 'Address' },
    preferences: { path: '/checkout/preferences', stepId: 3 },
    giftaid: { path: '/checkout/giftaid', stepId: 5 },
    payment: { path: '/checkout/payment', stepId: 6, stepIndicatorName: 'Payment' },
    'thank-you': { path: '/checkout/thank-you', stepId: 7 },
  },
};
const DONATION_FORM_STEPS = DONATION_FORM_STEPS_BY_REGION[DEFAULT_COUNTRY_CODE];

const DONATION_TYPES_PATH_ALIAS = {
  [SD]: 'single',
  [RG]: 'monthly',
};

const CATEGORIES = [
  { value: 'disaster-risk-reduction', label: 'Disaster Risk Reduction' },
  { value: 'graduation', label: 'Graduation' },
  { value: 'innovations', label: 'Innovations' },
  { value: 'learning', label: 'Learning' },
  { value: 'gender-equality', label: 'Gender Equality' },
  { value: 'conservative-agriculture', label: 'Conservation Agriculture' },
  { value: 'monitoring-and-evaluation', label: 'Monitoring and Evaluation' },
];

const SUGGESTED_SEARCHES_TITLE = 'Explore';

/* Inspired by https://stackoverflow.com/a/46181/4853655. */
const EMAIL_EXPRESSION =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const LOQATE_ENDPOINT_IBAN =
  'https://api.addressy.com/InternationalBankValidation/Interactive/Validate/v1.00/json3.ws';
const LOQATE_ENDPOINT_UK =
  'https://api.addressy.com/BankAccountValidation/Interactive/Validate/v2.00/json3.ws';

const PAGE_LAYOUTS = {
  '/node/appeal': 'centered',
  '/node/country': 'twoColumns',
  '/node/news': 'centered',
  '/node/page': 'centered',
  '/node/press_release': 'centered',
  '/node/publication': 'centered',
  '/node/publication_landing': 'left',
  '/node/regular_giving_upgrades_campaign': 'twoColumns',
  '/node/section_index_page': 'twoColumns',
  '/node/standard_info_page': 'twoColumns',
  '/node/story': 'centered',
};

// We need to know Knowldgge hub URL to be able to generate URLs for
// related categories on the Resource page.
// TODO: Move it to the site settings or think how to avoid it at all.
const KNOWLEDGE_HUB_URL = '/knowledge-hub';

const FUNDRAISING_COSTS_DEFAULT_FORMULA = '5%';

module.exports = {
  BACKEND_URL,
  FRONTEND_CNET_URL,
  FRONTEND_GIFTS_URL,
  ENVIRONMENT,
  DEFAULT_COUNTRY_CODE,
  SD,
  RG,
  DONATION_FORM_STEPS,
  DONATION_TYPES_PATH_ALIAS,
  CATEGORIES,
  SUGGESTED_SEARCHES_TITLE,
  EMAIL_EXPRESSION,
  RECAPTCHA_SITE_KEY,
  IDEAL_POSTCODES_API_KEY,
  AUTO_ADDRESS_API_KEY,
  AUTO_ADDRESS_GIFTS_API_KEY,
  CONSUMER_ID,
  LOQATE_ENDPOINT_IBAN,
  LOQATE_ENDPOINT_UK,
  ROLLBAR_CLIENT_ACCESS_TOKEN,
  COOKIEBOT_ID,
  PAGE_LAYOUTS,
  KNOWLEDGE_HUB_URL,
  FUNDRAISING_COSTS_DEFAULT_FORMULA,
  HTTP_AUTH_USER,
  HTTP_AUTH_PASS,
  PAYMENT_SECRET_HEADER_NAME,
  CSP_CENTRAL_ENDPOINT_ID,
  DEFAULT_CURRENCY,
  GTM_QUERY,
  GTM_ID,
  GIFTS_GTM_QUERY,
  GIFTS_GTM_ID,
  GIFTS_COOKIEBOT_ID,
  PAYPAL_CLIENT_TEST,
  PAYPAL_CLIENT_LIVE,
  PAYPAL_GIFTS_CLIENT_TEST,
  PAYPAL_GIFTS_CLIENT_LIVE,
  TEST_SUITE_SECRET_HEADER_NAME,
  STRIPE_PUBLISHABLE_TEST,
  STRIPE_PUBLISHABLE_LIVE,
  STRIPE_GIFTS_PUBLISHABLE_TEST,
  STRIPE_GIFTS_PUBLISHABLE_LIVE,
};
